var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',{staticClass:"pt-0 pl-0",staticStyle:{"color":"#000"}},[_vm._v("Biên bản nghiệm thu")]),_c('TableBienBanNghiemThu',{attrs:{"customer_id":_vm.id,"isShowListTotal":_vm.isShowListTotal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }